module.exports = __webpack_public_path__ + "img/4-4.2c8f83fa.svg";